import { UIHeading2, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';
import { IAdvantageItemProps } from '../utils/types';

export const AdvantageItem: React.FC<IAdvantageItemProps> = ({ heading, title, image }) => {
  return (
    <div className={style['item']}>
      <div className={style['title']}>
        <UIHeading2>{heading}</UIHeading2>
        <UIText2>{title}</UIText2>
      </div>

      <div className={style['image']}>
        <img src={image} />
      </div>
    </div>
  );
};
